@if(tags && tags.length > 0) {
<div class="row mb-3">
  <div class="col-1 p-0 text-end" *ngIf="tipoCatalogo === 'Automatico'">
    <a class="btn p2" (click)="owlCar.prev()"
      ><i class="fa-sharp fa-light fa-circle-chevron-left fa-2xl"></i
    ></a>
  </div>
  <div class="col-1 p-0 text-start" *ngIf="tipoCatalogo != 'Automatico'">
    <a class="btn p2" (click)="owlCar.prev()"
      ><i class="fa-solid fa-chevron-left"></i
    ></a>
  </div>
  <div class="col-10 p-0">
    <owl-carousel-o [options]="customOptions" #owlCar>
      <ng-container *ngFor="let slide of tags; index as i">
        <ng-template carouselSlide [id]="i.toString()" class="test2">
          <div class="element">
            <div class="element2" (click)="irTag(slide.index)">
              <b>{{ slide.tag }}</b>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
  <div class="col-1 p-0 text-start" *ngIf="tipoCatalogo === 'Automatico'">
    <a class="btn p2" (click)="owlCar.next()"
      ><i class="fa-sharp fa-light fa-circle-chevron-right fa-2xl"></i
    ></a>
  </div>
  <div class="col-1 p-0 text-start" *ngIf="tipoCatalogo != 'Automatico'">
    <a class="btn p2" (click)="owlCar.next()"
      ><i class="fa-solid fa-chevron-right"></i
    ></a>
  </div>
</div>
}
